import { connect } from 'react-redux'
// import React from 'react'
// import PropTypes from 'prop-types'
import R from 'ramda'

import {
  getPageData
} from '_utils'

import {
  setNavigation
} from '_actions'

import {
  // create,
  refresh,

  removeKeyedSessionMachine,
  deactivateKey,
  postKey,

  getStatePath,
  activationCodesStatePath,
  activationCodesRefreshList,
  activationCodesDeactivate
} from '_actions/thirdParty'

import ThirdPartyInstitution from './page'

const mapStateToProps = (state, ownProps) => ({
  institution: R.path(getStatePath(ownProps.institutionId).concat('institution'), state),
  request: R.path(getStatePath(ownProps.institutionId).concat('request'), state),
  acData: getPageData(activationCodesStatePath(ownProps.institutionId), state)
})

const mapDispatchToProps = dispatch => ({
  // institution actions
  onRefreshInstitution: R.compose(dispatch, refresh), // ({institutionId})
  // keys
  keyFuncs: {
    onAddKey: R.compose(dispatch, postKey), // ({institutionId, payload})
    onRemoveKey: R.compose(dispatch, deactivateKey), // ({institutionId, keyId})
    onRemoveKeyMachine: R.compose(dispatch, removeKeyedSessionMachine) // ({institutionId, keyId, machineId})
  },
  // institutional Activation codes
  acFuncs: {
    onRefreshOwner: R.compose(dispatch, refresh), // ({institutionId})
    onDeactivateAc: R.compose(dispatch, activationCodesDeactivate), // ({institutionId, licenseId}
    onRefreshInstitution: R.compose(dispatch, refresh), // ({institutionId})
    setNavigation: R.compose(dispatch, setNavigation), // ({pageName, ids[]})
    goToPage: R.compose(dispatch, activationCodesRefreshList) // { institutionId, pageNum, perPage, ids, showExpired, filter }
  }
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThirdPartyInstitution)



// WEBPACK FOOTER //
// ./webAdmin/components/thirdParty/index.js